import React from "react";

export default function StatCard({ label, value, hint, icon }) {
  return (
    <div className="rounded-lg border border-gray-800 bg-gray-900/50 p-4 md:p-5">
      <div className="flex items-center gap-3">
        {icon && (
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-800">
            {icon}
          </div>
        )}
        <div className="min-w-0">
          <p className="text-xs font-medium text-gray-500">{label}</p>
          <p className="mt-0.5 text-lg font-semibold text-white truncate">{value}</p>
          {hint && <p className="mt-1 text-[10px] text-gray-600">{hint}</p>}
        </div>
      </div>
    </div>
  );
}
